import { useEffect, useState } from "react";
import AccountSkeleton from "../../../components/skeleton/DashboardView/accountSkeleton";
import { StaticVariables } from "../../../Utils/StaticVariables";
import "./Account.css";
import { useAuth } from "../../../hooks/useAuth";
import Username from "./AccountSection/Username";
import Name from "./AccountSection/Name";
import { useLoadUser } from "../../../Utils/customHooks/useLoadUser";
import Email from "./AccountSection/Email";
import Phone from "./AccountSection/Phone";
import Subscription from "./AccountSection/Subscription";
import { Button, Input, Modal } from "antd";
import validator from "validator";
import { inviteTeamMember } from "../../../Utils/SupabaseServices/UserDatabase";
import Password from "./AccountSection/Password";
import AddMember from "./AccountSection/AddMember";

const Account = (props: any) => {
  const { user: sessionUser, session, isAdmin, adminId, isMember } = useAuth();
  const { username, setIsEmail } = props;
  const [isEmailChanged, setIsEmailChanged] = useState(false);
  const [changedEmail, setChangedEmail] = useState(false);
  const {
    isLoading: userLoading,
    data: userData,
    refetch,
  }: any = useLoadUser(username);

  return (
    <div>
      {userLoading ? (
        <AccountSkeleton />
      ) : (
        <>
          <div className="details">
            <h1 className="dashboard-mobile-hide">
              {StaticVariables().ACCOUNT_TITLE}
            </h1>
            <div className="account-values-grid">
              <Username username={username} sessionUser={sessionUser} />

              <Name
                title="Name"
                username={username}
                userData={userData}
                setIsName={props.setIsName}
                user_id={sessionUser?.id}
                refetch={refetch}
              />
              {!isAdmin && isMember && userData?.email !== session?.user?.email && (
                <Name
                  title="Display Name"
                  username={username}
                  userData={userData}
                  setIsName={props.setIsName}
                  user_id={sessionUser?.id}
                  refetch={refetch}
                />
              )}
              <Email
                username={username}
                userData={userData}
                setIsEmail={props.setIsEmail}
                setIsEmailVerified={props.setIsEmailVerified}
                user_id={sessionUser?.id}
                isAdmin={isAdmin}
                session={session}
                setChangedEmail={setChangedEmail}
                refetch={refetch}
                setIsEmailChanged={setIsEmailChanged}
                isEmailChanged={isEmailChanged}
              />

              <Phone
                username={username}
                userData={userData}
                setIsPhone={props.setIsPhone}
                user_id={sessionUser?.id}
                refetch={refetch}
              />

              <Password
                username={username}
                userData={userData}
                setIsEmail={props.setIsEmail}
                setIsEmailVerified={props.setIsEmailVerified}
                user_id={sessionUser?.id}
                isAdmin={isAdmin}
                session={session}
                changedEmail={changedEmail}
                refetch={refetch}
              />

              <Subscription
                username={username}
                userData={userData}
                user_id={sessionUser?.id}
                refetch={refetch}
              />
            </div>

            {/* Always show AddMember component (which contains MembersList) but let AddMember handle member restrictions */}
            {userData.show_add_member && <AddMember userData={userData} isEmailChanged={isEmailChanged} />}
          </div>
        </>
      )}
    </div>
  );
};

export default Account;
